import React from 'react';
import { Container, Grid, Typography } from '@mui/material';

const NewPage = ({ title, children }) => {
  return (
    <Container maxWidth="lg">
      <Grid container spacing={1}>
        <Grid item xs={12} sx={{ margin: '16px 0' }}>
          <Typography variant="h4" gutterBottom>
            {title}
          </Typography>
        </Grid>
        <Grid item container xs={12} spacing={1} sx={{ mb: 4 }}>
          {children}
        </Grid>
      </Grid>
    </Container>
  );
};

export default NewPage;
